import Icon, { IconName } from "components/ui/Icon";
import UILabel from "components/ui/UILabel";
import React from "react";
import styled, { css } from "styled-components";
import { formatCurrency } from "utils/string";
import { mediaMax } from "utils/theme";

const Amount = styled(UILabel.XLarge)`
  font-size: 21px;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;

  display: none;
`;

const Wrapper = styled.div<{ $status?: Status }>`
  position: relative;

  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  border-radius: ${(props) => props.theme.borderRadius.small}px;
  border: 1.5px solid transparent;

  ${(props) => !props.$status && css``}

  ${(props) =>
    props.$status === "active" &&
    css`
      ${Amount} {
        color: ${(props) => props.theme.colors.primary};
      }
    `}

  ${(props) =>
    props.$status === "warning" &&
    css`
      border-color: ${(props) => props.theme.colors.disabled}87;

      ${IconWrapper} {
        display: block;
      }
    `}

  ${(props) =>
    props.$status === "success" &&
    css`
      background: ${(props) => props.theme.colors.secondary}87;
      color: ${(props) => props.theme.reverseColors.secondary};
      border: 1.5px solid ${(props) => props.theme.colors.primary};

      ${Amount} {
        color: ${(props) => props.theme.colors.primary};

        font-weight: ${props.theme.fontWeights.bold};
      }

      ${IconWrapper} {
        display: block;
      }
    `}
    
  ${mediaMax("lg")} {
    padding: 12px;

    ${IconWrapper} {
      top: 12px;
      right: 12px;
    }
  }
`;

type Status = "active" | "success" | "warning";

interface Props {
  status?: Status;
  amount: number;
  title: string;
}

const getIconName = (status?: Status): IconName => {
  switch (status) {
    case "success":
      return "shield";
    case "warning":
      return "warningTriangle";
    default:
      return "infoCircle";
  }
};

const Balance: React.FC<Props> = ({ status, amount, title }) => (
  <Wrapper $status={status}>
    <UILabel.Medium>{title}</UILabel.Medium>
    <Amount>{formatCurrency(amount, true).split(".")[0]}</Amount>
    <IconWrapper>
      <Icon name={getIconName(status)} />
    </IconWrapper>
  </Wrapper>
);

export default Balance;
